import { Trans } from '@lingui/macro'
import { BrowserEvent, InterfaceElementName, SwapEventName } from '@uniswap/analytics-events'
import { Percent } from '@uniswap/sdk-core'
import { TraceEvent, useTrace } from 'analytics'
import AnimatedDropdown from 'components/AnimatedDropdown'
import Column from 'components/Column'
import { LoadingOpacityContainer } from 'components/Loader/styled'
import { RowBetween, RowFixed } from 'components/Row'
import { formatCommonPropertiesForTrade } from 'lib/utils/analytics'
import { useState } from 'react'
import { ChevronDown, RefreshCw } from 'react-feather'
import { InterfaceTrade } from 'state/routing/types'
// import { isSubmittableTrade } from 'state/routing/utils'
import styled, { useTheme } from 'styled-components'
import { ButtonText, ThemedText } from 'theme/components'
import { useFormatter } from 'utils/formatNumbers'
import swap from 'assets/svg/swap.svg'

// import GasEstimateTooltip from './GasEstimateTooltip'
import SwapLineItem, { SwapLineItemType } from './SwapLineItem'
import TradePrice from './TradePrice'

const StyledHeaderRow = styled(RowBetween)<{ disabled: boolean; open: boolean }>`
  padding: 0;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
`

const RotatingArrow = styled(ChevronDown)<{ open?: boolean }>`
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'none')};
  transition: transform 0.1s linear;
`

const SwapDetailsWrapper = styled(Column)`
  padding-top: ${({ theme }) => theme.grids.md};
`

const Wrapper = styled(Column)`
  padding: 12px 0px 0px;
`

const StyledRefreshButton = styled(ButtonText)`
  && {
    display: inline-flex;
    color: ${({ theme }) => theme.neutral1};
    background-color: ${({ theme }) => theme.surface3};
    font-size: 14px;
    line-height: 1;
    padding: 4px;
    border-radius: 20px;
    height: fit-content;
  }
`

interface SwapDetailsProps {
  trade?: InterfaceTrade
  syncing: boolean
  loading: boolean
  allowedSlippage: Percent
  refetch?: () => void
}

export default function SwapDetailsDropdown(props: SwapDetailsProps) {
  const { trade, syncing, loading, allowedSlippage, refetch } = props

  const [showDetails, setShowDetails] = useState(false)
  const trace = useTrace()

  return (
    <Wrapper>
      <TraceEvent
        events={[BrowserEvent.onClick]}
        name={SwapEventName.SWAP_DETAILS_EXPANDED}
        element={InterfaceElementName.SWAP_DETAILS_DROPDOWN}
        properties={{
          ...(trade ? formatCommonPropertiesForTrade(trade, allowedSlippage) : {}),
          ...trace,
        }}
        shouldLogImpression={!showDetails}
      >
        <StyledHeaderRow
          data-testid="swap-details-header-row"
          onClick={() => setShowDetails(!showDetails)}
          disabled={!trade}
          open={showDetails}
        >
          <RowFixed>
            <img src={swap} alt="Swap Icon" width="16" height="16" className="mr-1" />

            {trade ? (
              <LoadingOpacityContainer $loading={syncing} data-testid="trade-price-container">
                <TradePrice price={trade.executionPrice} />

                {/* {!syncing && refetch ? (
                  <StyledRefreshButton
                    onClick={(e) => {
                      e.stopPropagation()
                      refetch()
                    }}
                  >
                    <RefreshCw width="1em" height="1em" />
                  </StyledRefreshButton>
                ) : null} */}
              </LoadingOpacityContainer>
            ) : loading || syncing ? (
              <ThemedText.DeprecatedMain fontSize={14}>
                <Trans>Fetching best price...</Trans>
              </ThemedText.DeprecatedMain>
            ) : null}
          </RowFixed>
          <RowFixed gap="xs">
            {/*{!showDetails && isSubmittableTrade(trade) && (*/}
            {/*  <GasEstimateTooltip trade={trade} loading={syncing || loading} />*/}
            {/*)}*/}
            <RotatingArrow
              stroke="#777E90"
              // stroke={trade ? theme.neutral3 : theme.surface2}
              open={Boolean(trade && showDetails)}
            />
          </RowFixed>
        </StyledHeaderRow>
      </TraceEvent>
      <AdvancedSwapDetails {...props} open={showDetails} />
    </Wrapper>
  )
}

function AdvancedSwapDetails(props: SwapDetailsProps & { open: boolean }) {
  const { open, trade, allowedSlippage, syncing = false } = props
  const format = useFormatter()

  if (!trade) return null

  const lineItemProps = { trade, allowedSlippage, format, syncing }

  return (
    <AnimatedDropdown open={open}>
      <SwapDetailsWrapper gap="md" data-testid="advanced-swap-details">
        <SwapLineItem {...lineItemProps} type={SwapLineItemType.PRICE_IMPACT} />
        <SwapLineItem {...lineItemProps} type={SwapLineItemType.MAX_SLIPPAGE} />
        {/*<SwapLineItem {...lineItemProps} type={SwapLineItemType.INPUT_TOKEN_FEE_ON_TRANSFER} />*/}
        {/*<SwapLineItem {...lineItemProps} type={SwapLineItemType.OUTPUT_TOKEN_FEE_ON_TRANSFER} />*/}
        <SwapLineItem {...lineItemProps} type={SwapLineItemType.SWAP_FEE} />
        {/*<SwapLineItem {...lineItemProps} type={SwapLineItemType.NETWORK_COST} />*/}
        {/*<SwapLineItem {...lineItemProps} type={SwapLineItemType.ROUTING_INFO} />*/}
      </SwapDetailsWrapper>
    </AnimatedDropdown>
  )
}
